import $http from '@/api';
import uploadApi from '@/modules/upload/api';

export default {
  async create(payload, type = 'article') {
    return $http.post(`/api/content/${type}`, payload);
  },
  async createContentImageFromUrl(url, payload) {
    const blob = await uploadApi.getImageBlob(url);
    const file = new File([blob], url.substring(url.lastIndexOf('/')), { type: 'image/jpeg' });

    const data = new FormData();
    data.append('file', file);
    data.append('payload', JSON.stringify(payload));

    return this.create(data, 'image');
  },
};
